// extracted by mini-css-extract-plugin
export default {"menuContainer":"ExpedienteCriteriosPage_menuContainer__OPFsz","menuOption":"ExpedienteCriteriosPage_menuOption__Ci7CY","selected":"ExpedienteCriteriosPage_selected__YEDVk"};